var _g, _g2, _g3, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgQuestionTypeOeImg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 125,
    height: 109,
    viewBox: "0 0 125 109",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 25.8687,
    y: 16.7539,
    width: 83.2247,
    height: 64.9945,
    rx: 2.77093,
    fill: "white",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 26.2059,
    y: 16.2547,
    width: 82.5512,
    height: 64.321,
    rx: 2.4342,
    stroke: "black",
    strokeWidth: 0.673465,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M93.6372 41.326C93.6372 40.2749 93.2197 39.2669 92.4765 38.5236C91.7332 37.7804 90.7252 37.3629 89.6741 37.3629H81.748V29.4367C81.748 28.3856 81.3304 27.3776 80.5872 26.6344C79.844 25.8912 78.836 25.4736 77.7849 25.4736H46.0803C45.0292 25.4736 44.0212 25.8912 43.2779 26.6344C42.5347 27.3776 42.1172 28.3856 42.1172 29.4367V61.1414C42.1184 61.5141 42.2247 61.8791 42.4239 62.1941C42.6231 62.5092 42.9072 62.7617 43.2435 62.9226C43.5798 63.0835 43.9546 63.1463 44.325 63.1038C44.6953 63.0612 45.0462 62.915 45.3372 62.682L54.0064 55.6921V63.1229C54.0064 64.174 54.424 65.182 55.1672 65.9252C55.9104 66.6684 56.9184 67.086 57.9695 67.086H81.151L90.4172 74.5712C90.7678 74.8549 91.2047 75.0104 91.6557 75.0121C92.1812 75.0121 92.6852 74.8034 93.0568 74.4318C93.4285 74.0601 93.6372 73.5561 93.6372 73.0306V41.326ZM83.0979 63.5638C82.7473 63.2802 82.3104 63.1246 81.8594 63.1229H57.9695V55.1967H77.7849C78.836 55.1967 79.844 54.7792 80.5872 54.036C81.3304 53.2928 81.748 52.2847 81.748 51.2337V41.326H89.6741V68.8817L83.0979 63.5638Z",
    fill: "#E3DFE9"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M61.7095 43.4308C63.31 43.4308 64.6075 42.1333 64.6075 40.5328C64.6075 38.9322 63.31 37.6348 61.7095 37.6348C60.109 37.6348 58.8115 38.9322 58.8115 40.5328C58.8115 42.1333 60.109 43.4308 61.7095 43.4308Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.0835 43.4308C52.6841 43.4308 53.9816 42.1333 53.9816 40.5328C53.9816 38.9322 52.6841 37.6348 51.0835 37.6348C49.483 37.6348 48.1855 38.9322 48.1855 40.5328C48.1855 42.1333 49.483 43.4308 51.0835 43.4308Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.3355 43.4308C73.936 43.4308 75.2335 42.1333 75.2335 40.5328C75.2335 38.9322 73.936 37.6348 72.3355 37.6348C70.735 37.6348 69.4375 38.9322 69.4375 40.5328C69.4375 42.1333 70.735 43.4308 72.3355 43.4308Z",
    fill: "white"
  }))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.1499 57.8963L76.5273 18.6094L8.1499 57.8963Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M110.617 34.1237L115.947 31.0215L110.617 34.1237Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.6472 88.4333L54.9763 85.3311",
    stroke: "#E3DFE9",
    strokeWidth: 16.7314,
    strokeLinecap: "round"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M113.181 77.4591C114.012 77.5459 114.617 78.2917 114.53 79.1234C114.443 79.9551 113.698 80.5598 112.866 80.473C112.034 80.3862 111.429 79.6404 111.516 78.8087C111.603 77.977 112.349 77.3723 113.181 77.4591Z",
    stroke: "#8E8E8E",
    strokeWidth: 0.778901
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.5393 94.8955C32.907 95.0382 33.9015 96.2646 33.7587 97.6323C33.6159 98.9999 32.3895 99.9944 31.0219 99.8516C29.6542 99.7088 28.6597 98.4824 28.8025 97.1148C28.9453 95.7471 30.1717 94.7527 31.5393 94.8955Z",
    stroke: "#8E8E8E",
    strokeWidth: 1.28085
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M59.6707 6.88959C61.0383 7.03239 62.0328 8.25875 61.89 9.6264C61.7472 10.994 60.5209 11.9885 59.1532 11.8457C57.7856 11.7029 56.7911 10.4766 56.9339 9.10893C57.0767 7.74128 58.3031 6.7468 59.6707 6.88959Z",
    stroke: "#8E8E8E",
    strokeWidth: 1.28085
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1.98518 38.6621C2.61339 38.6621 3.12344 39.1722 3.12344 39.8004C3.12344 40.4286 2.61339 40.9386 1.98518 40.9386C1.35698 40.9386 0.846924 40.4286 0.846924 39.8004C0.846924 39.1722 1.35698 38.6621 1.98518 38.6621Z",
    stroke: "#8E8E8E",
    strokeWidth: 0.936249
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M122.535 31.1611C123.164 31.1611 123.674 31.6712 123.674 32.2994C123.674 32.9276 123.164 33.4377 122.535 33.4377C121.907 33.4377 121.397 32.9276 121.397 32.2994C121.397 31.6712 121.907 31.1611 122.535 31.1611Z",
    stroke: "#8E8E8E",
    strokeWidth: 0.936249
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M103.379 5.86426L104.678 1.48421",
    stroke: "#4D5762",
    strokeWidth: 0.545506
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M101.911 3.05566L106.291 4.35508",
    stroke: "#4D5762",
    strokeWidth: 0.545506
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M6.60107 80.4473L7.74031 76.0229",
    stroke: "#4D5762",
    strokeWidth: 0.545506
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M5.03198 77.6934L9.45639 78.8326",
    stroke: "#4D5762",
    strokeWidth: 0.545506
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M101.572 100.213L102.463 95.7319",
    stroke: "#4D5762",
    strokeWidth: 0.545506
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M99.8523 97.5508L104.333 98.4419",
    stroke: "#4D5762",
    strokeWidth: 0.545506
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestionTypeOeImg);
export default __webpack_public_path__ + "static/media/question_type_oe_img.91f4b8963efdd775d56a34bdf750e68f.svg";
export { ForwardRef as ReactComponent };